import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { SERVICES } from "../data/content";

export default function Services() {
  return (
    <section data-testid="services-section" className="relative w-full bg-[#050505]">
      <div className="pad-x pb-4 pt-24 md:pt-32">
        <Reveal>
          <span className="overline">What We Do</span>
          <h2 className="display-title mt-3 text-white">A full-spectrum studio</h2>
        </Reveal>
      </div>

      <div>
        {SERVICES.map((s, i) => (
          <Link
            key={s.id}
            to="/services"
            data-testid={`service-card-${s.id}`}
            className="group relative flex min-h-[34vh] w-full items-center overflow-hidden"
          >
            {/* hover background image */}
            <img
              src={s.image}
              alt=""
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-30"
            />
            <div className="pad-x relative z-10 flex w-full flex-col gap-4 py-10 md:flex-row md:items-center md:justify-between">
              <div className="flex items-start gap-6 md:items-center md:gap-10">
                <span className="font-playfair text-xl text-gold md:text-2xl">0{i + 1}</span>
                <div>
                  <h3 className="font-playfair text-4xl font-bold text-white transition-transform duration-500 group-hover:translate-x-2 md:text-6xl">
                    {s.title}
                  </h3>
                  <p className="mt-2 max-w-xl text-sm font-light text-neutral-400 md:text-base">{s.short}</p>
                </div>
              </div>
              <ArrowUpRight className="text-neutral-500 transition-all duration-500 group-hover:text-gold md:group-hover:-translate-y-1 md:group-hover:translate-x-1" size={34} />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
